import { Button } from '@/components/foundry';
import Labs from '../os/v2/pages/Labs';
import ControlRoomShopWindow from '../library/shop/ControlRoomShopWindow';

/**
 * LabsSurface — the PUBLIC front door for AI Brand Lab's interactive tools.
 *
 * No auth: anyone with the link can use the tools (they're teaching +
 * demonstration surfaces, no sensitive data). Inputs persist in localStorage,
 * and the "save" action captures an email instead of requiring a login.
 * Members get the same tools inside the OS (signed in) with save-to-profile.
 *
 * Reached at `tools.theaibrandlab.com` (prod) or `?surface=labs` (local/dev).
 * `/control-room` (or `?view=control-room`) on this surface renders the public
 * Control Room shop-window (E3) — same scaffolding, curated reveal.
 */
export default function LabsSurface() {
  const params = new URLSearchParams(window.location.search);
  const isShopWindow =
    window.location.pathname === '/control-room' || params.get('view') === 'control-room';
  return (
    <div
      className="min-h-[100dvh] bg-fd-bg font-geist text-fd-text antialiased"
      style={{
        backgroundImage:
          'linear-gradient(var(--fd-grid) 1px, transparent 1px),' +
          'linear-gradient(90deg, var(--fd-grid) 1px, transparent 1px)',
        backgroundSize: '64px 64px',
        backgroundPosition: '-1px -1px',
      }}
    >
      <header className="sticky top-0 z-40 flex h-14 items-center justify-between border-b border-fd-border bg-fd-bg/85 px-6 backdrop-blur">
        <a href="/?surface=marketing" className="flex items-center gap-2.5" aria-label="AI Brand Lab home">
          <span
            className="grid h-7 w-7 place-items-center rounded-[4px] border-[1.5px] border-fd-text bg-fd-accent font-geist-mono text-[14px] font-bold text-[oklch(0.16_0.005_95)]"
            style={{ boxShadow: '2px 2px 0 0 var(--fd-text)' }}
          >
            A
          </span>
          <span className="text-[13px] font-bold uppercase tracking-[-0.005em] text-fd-text">AI Brand Lab</span>
          <span className="ml-1 hidden font-caveat text-[16px] leading-none text-fd-text-subtle sm:inline">labs</span>
        </a>
        <nav className="flex items-center gap-3">
          {!isShopWindow && (
            <a
              href="/control-room?surface=labs&view=control-room"
              className="font-geist-mono text-[11px] uppercase tracking-[0.08em] text-fd-text-muted underline-offset-4 hover:text-fd-text hover:underline"
            >
              The Control Room
            </a>
          )}
          <Button asChild variant="primary" size="sm">
            <a href="/?surface=marketing">Join the Lab</a>
          </Button>
        </nav>
      </header>

      {isShopWindow ? <ControlRoomShopWindow /> : <Labs saveMode="email" />}

      <footer className="border-t border-fd-border px-6 py-7 text-center">
        <p className="font-geist-mono text-[11px] tracking-[0.02em] text-fd-text-subtle">
          Built by AI Brand Lab — a coaching business with a memory.
        </p>
      </footer>
    </div>
  );
}
